import Vue from "vue";
import VueCookies from "vue-cookies";
Vue.use(VueCookies);

export function getToken() {
  return Vue.$cookies.get("token");
}

export function getUserIsLogged(state) {
  state.isLogged = Vue.$cookies.isKey("userIsLogged");
  return state.isLogged;
}

export function userIsAParent(state) {
  state.type = Vue.$cookies.get("userType");
  return state.type == "parent";
}

export function getUserId(state) {
  state.userData["id"] = Vue.$cookies.get("userId");
  return state.userData["id"];
}

export function getUserIdUnique(state) {
  state.userData["unique"] = Vue.$cookies.get("unique");
  return state.userData["unique"];
}

export function getUserName(state) {
  state.userData["name"] = Vue.$cookies.get("userName");
  return state.userData["name"];
}

export function getUserLastName(state) {
  return state.userData["last_name"];
}

export function getUserBirthDate(state) {
  return state.userData["birthdate"];
}

export function getChildrenIds(state) {
  return state.childrenIds;
}

export function getChildrenCounter(state) {
  state.childrenCounter = Vue.$cookies.get("childCount");
  return state.childrenCounter;
}

export function getChildrenData(state) {
  return state.childrenData;
}

export function getChildSelectedId(state) {
  state.childSelectedId = Vue.$cookies.get("childSelectedId");
  return state.childSelectedId;
}

export function getChildSelectedName(state) {
  state.childSelectedName = Vue.$cookies.get("childSelectedName");
  return state.childSelectedName;
}

export function error(state) {
  return state.error;
}

export function errorMessage(state) {
  return state.errorMessage;
}

export function getParentName(state) {
  state.userData["parentName"] = Vue.$cookies.get("parentName");
  return state.userData["parentName"];
}

export function getParentId(state) {
  state.userData["parentId"] = Vue.$cookies.get("parentId");
  return state.userData["parentId"];
}

export function getParentData(state) {
  return state.userData["parent"];
}

export function getGendersList(state) {
  var response = [];
  state.genders.forEach(element => {
    response.push({ value: element.id, text: element.name });
  });

  return response;
}

export function getIsFirstTime(state) {
  var isFirstTime = true;
  state.type = Vue.$cookies.get("userType");
  if (state.type == "parent") {
    state.childrenCounter = Vue.$cookies.get("childCount");
    isFirstTime = state.childrenCounter == 0;
  } else {
    state.childFirstTime = Vue.$cookies.get("childFirstTime");
    isFirstTime = state.childFirstTime == "true";
  }
  return isFirstTime;
}

export function getNotificationSetup(state) {
  return state.notificationSetup;
}

export function getTheme(state) {
  state.theme = Vue.$cookies.get("theme");
  return state.theme;
}

export function getUserScore(state) {
  return state.userData["stars"];
}

export function getUserObject(state) {
  return state.userData;
}

export function getUserScoreAll(state) {
  return state.userData["score"];
}

export function getUserAvatar(state) {
  return state.userData["avatar"];
}

export function getUserLevel(state) {
  return `${state.userData["level"]}`;
}

export function getNotificationsCount(state) {
  return state.notifications.length;
}

export function getNotifications(state) {
  return state.notifications;
}

export function getChildInfo(state) {
  return id => {
    return state.childProfile[id];
  };
}

export function getTimeZoneList(state) {
  var response = [];
  state.timeZoneList.forEach(element => {
    response.push({ value: element.value, text: element.text });
  });
  return response;
}

export function getTimeZone(state) {
  return state.timeZone["value"];
}

export function getChildAvatar(state) {
  return state.childAvatar;
}

export function getOriginalParentId(state){
  state.originalParentId = Vue.$cookies.get("originalParentId");
  return state.originalParentId
}